import {
	INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS,
	type InvitedAppShortcutAllowedApsKey,
	type InvitedAppShortcutAllowedTargetAppKey,
} from '../types';

/**
 * Check if the APS key is allowed
 * @param apsKey - The APS key to check if it is allowed
 * @returns True if the APS key is allowed, false otherwise
 */
export const isAllowedApsKey = (
	apsKey: string | undefined,
): apsKey is InvitedAppShortcutAllowedApsKey => {
	if (!apsKey) {
		return false;
	}
	return (INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS as unknown as string[]).includes(apsKey);
};

/**
 * Get the app key by the APS key
 * @param apsKey - The APS key to get the app key for
 * @returns The app key
 */
export const getAppKeyByApsKey = (
	apsKey: InvitedAppShortcutAllowedApsKey,
): InvitedAppShortcutAllowedTargetAppKey => {
	switch (apsKey) {
		case 'JIRA_SOFTWARE':
			return 'jira';
		case 'CONFLUENCE':
			return 'confluence';
		default:
			// This should never happen, throw it just in case if we add a new APS key without adding a new app key
			throw new Error(`Invalid APS key: ${apsKey}`);
	}
};
